import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiNewsletterSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  heading: string;
  intro: string;
  successMessage: string;
}

export class NewsletterSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  intro: MDXRemoteSerializeResult;
  successMessage: MDXRemoteSerializeResult;
}
